var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3.944c-1.16 0-2.106.91-2.164 2.056h4.328A2.167 2.167 0 0 0 12 3.944m0-1A3.167 3.167 0 0 0 8.835 6H4.5a.5.5 0 0 0 0 1h1.049l1.358 12.643a1.5 1.5 0 0 0 1.491 1.34h7.204a1.5 1.5 0 0 0 1.491-1.34L18.451 7H19.5a.5.5 0 0 0 0-1h-4.335A3.167 3.167 0 0 0 12 2.944M7.901 19.536 6.557 7.017h10.886L16.1 19.536a.5.5 0 0 1-.497.447H8.398a.5.5 0 0 1-.497-.447M11 10.121a.5.5 0 1 0-1 0v6.241a.5.5 0 0 0 1 0zm2.5-.5a.5.5 0 0 1 .5.5v6.241a.5.5 0 1 1-1 0v-6.241a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
};
export default SvgTrashIcon;